import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { IPrimitiveProps } from "../section/Primitive"
import MenuMobile from "./menu/MenuMobile"
import MenuScreen from "./menu/MenuScreen"

/* Protopia Ecosystem component */ 
const MenuPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const {width} = useLandingSize()    
    if(width > WINDOW_WIDTH.TABLET){
        return <MenuScreen {...props} />
    }
    return <MenuMobile {...props} />
}
export default MenuPrimitive